import dayjs from 'dayjs'

/**
 * Sanitiza dados de um paciente antes de enviar à API ou exibir no modal.
 * @param {import('@/types/api').Paciente} paciente
 * @returns {import('@/types/api').Paciente}
 */
export function prepararPaciente(paciente) {
  return {
    id: paciente.id,
    primeiro_nome: paciente.primeiro_nome || "",
    sobrenome: paciente.sobrenome || "",
    dn: paciente.dn ? dayjs(paciente.dn).format("YYYY-MM-DD") : "1900-01-01",
    idade: typeof paciente.idade === "number" ? paciente.idade : 0,
    sexo: paciente.sexo || "O",
    indicacao_clinica: paciente.indicacao_clinica || "Não informado",
    forma_de_capitacao: paciente.forma_de_capitacao || "",
    sistema_inscrito: paciente.sistema_inscrito || "DIETSYSTEM",
    uf: paciente.uf || "NA",
    telefone_formatado: paciente.telefone_formatado || "",
    email: paciente.email || "",
    receber_email: paciente.receber_email ?? true,
    motivo_nao_email: paciente.motivo_nao_email || "não informado",
    receber_whatsapp: paciente.receber_whatsapp ?? true,
    motivo_nao_whatsapp: paciente.motivo_nao_whatsapp || "não informado"
  }
}
